import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { "data-name": "Raggruppa 148" }, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "none",
    d: "M0 0h20v24H0z",
    "data-name": "Rettangolo 62"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    fill: "currentColor",
    d: "M.975 23.43v-4.513a12.4 12.4 0 0 1 12.4-12.4h1.56a6.94 6.94 0 0 1-2.338-2.2 8.1 8.1 0 0 1-1.249-3.2L12.337 1a7.25 7.25 0 0 0 1.111 2.8 6.29 6.29 0 0 0 5.577 2.722v1.086a6.28 6.28 0 0 0-5.6 2.757 7.2 7.2 0 0 0-1.09 2.764l-.993-.121a8.1 8.1 0 0 1 1.249-3.2 6.9 6.9 0 0 1 2.493-2.291h-1.709a11.4 11.4 0 0 0-11.4 11.4v4.513Z",
    "data-name": "Unione 2"
  })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "curved-right-arrow"}) } }